import { mapActions, mapGetters } from "vuex";

export default {
    name: "GuidesTrendBook",
    props: {},
    emits: [],
    components: {},
    setup() {},
    data() {
        return {}
    },
    created() {},
    mounted() {},
    watch: {},
    computed: {
        ...mapGetters({
            content: "guides/content",
        }),
    },
    methods: {
      ...mapActions({
        sendDownloadEvent: "guides/SEND_DOWNLOAD_EVENT"
      }),
      async handleDownloadButton(id, type) {
        const payload = {
          "viewable_id": id,
          "viewable_type": type
        }
        await this.sendDownloadEvent(payload)
      }
    }
}
